export default __webpack_public_path__ + "static/media/add_circle.c80d0e51.svg";